module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_9006.dbc4d734.png";